import { render, staticRenderFns } from "./ProductSubHeader.vue?vue&type=template&id=553e1a07&scoped=true&"
import script from "./ProductSubHeader.vue?vue&type=script&lang=js&"
export * from "./ProductSubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e1a07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553e1a07')) {
      api.createRecord('553e1a07', component.options)
    } else {
      api.reload('553e1a07', component.options)
    }
    module.hot.accept("./ProductSubHeader.vue?vue&type=template&id=553e1a07&scoped=true&", function () {
      api.rerender('553e1a07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductSubHeader.vue"
export default component.exports